import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import ids from '../../QestIds';
import ArizMeasurementsSection from './Sections/MeasurementsSection';
import ArizPreparationSection from './Sections/PreparationSection';
import ArizReferenceDensitySection from './Sections/ReferenceDensitySection';
import ArizResultsSection from './Sections/ResultsSection';
import ArizRetestSection from './Sections/RetestSection';

const qestids = [ids.nuclearFieldDensity.ARIZ_235.rev1992];

let ArizNuclearFieldDensityWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <ArizPreparationSection />
      <ArizRetestSection />
      <ArizReferenceDensitySection />
      <ArizMeasurementsSection />
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <ArizResultsSection />
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

ArizNuclearFieldDensityWorksheet.qestIds = qestids;

export { ArizNuclearFieldDensityWorksheet };
export default ArizNuclearFieldDensityWorksheet;
